<template>
  <section id="login-page">
    <div class="bg-image">
      <img
        src="@/assets/images/backgrounds/login-bg.png"
        class="image"
        alt="Login-background"
      />
    </div>
    <div class="inner-wrap">
      <el-form
        :model="formData"
        ref="ruleForm"
        @keyup.enter.prevent="submitForm('ruleForm')"
      >
        <el-row type="flex" justify="space-around" align="middle">
          <el-col :xs="24" :sm="24" :md="8" :lg="12" :xl="14" class="order-2">
            <div class="login-image">
              <img
                src="@/assets/images/login-form-image.png"
                alt="login-image"
                class="img-fluid"
              />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10" class="order-1">
            <div class="login-form">
              <div class="inner-wrap">
                <div class="company-logo">
                  <img src="@/assets/images/dlw-medical-group-logo.svg" alt="logo" />
                </div>
                <div class="username">
                  <el-input
                    class="user user-lower"
                    v-model="formData.identifier"
                    placeholder="Enter Email or username"
                  />
                  <div class="input-icon">
                    <img src="@/assets/images/icons/user-icon.svg" alt="" />
                  </div>
                  <span
                    class="err"
                    v-if="
                      getErrors && getErrors.identifier
                    "
                    >{{ this.getErrors.identifier }}</span
                  >
                </div>

                <div class="show-icon">
                  <el-input
                    v-model="formData.password"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Enter password"
                    class="pswd"
                  />
                  <el-button
                    class="show-eye-icon"
                    @click="showPassword = false"
                    v-if="showPassword"
                  >
                    <img src="@/assets/images/icons/hide-eye-icon.svg" alt="" />
                  </el-button>
                  <el-button
                    class="hide-eye-icon"
                    @click="showPassword = true"
                    v-else
                  >
                    <img src="@/assets/images/icons/show-eye-icon.svg" alt="" />
                  </el-button>
                  <div class="input-icon">
                    <img src="@/assets/images/icons/key-icon.svg" alt="" />
                  </div>
                  <span
                    class="err"
                    v-if="
                      getErrors && getErrors.password
                    "
                    >{{ this.getErrors.password }}</span
                  >
                </div>

                <el-button
                  class="login-btn"
                  type="primary"
                  :loading="loading"
                  :disabled="loading"
                  @click="submitForm('ruleForm')"
                  >LOGIN
                </el-button>
                <p
                  class="error invalid"
                  v-if="getErrors && getErrors.critical_error"
                >
                  {{ this.getErrors.critical_error }}
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Signin",
  computed: {
    ...mapGetters("auth", [
      "getGeneralErrorMessage",
      "getAuthenticationStatus",
      "getAuthenticatedUser",
    ]),
    ...mapGetters("errors", ["getErrors"]),
  },
  data() {
    return {
      loading: false,
      showPassword: false,
      formData: {
        email: "",
        password: "",
        err: "",
      },
      userTypes: [
        "HOSPITAL_ADMIN",
        "HOSPITAL_ACCOUNT_MANAGER",
        "HOSPITAL_PHYSICIAN",
        "HOSPITAL_MARKETING_MANAGER",
        "MARKETER",
        "ACCOUNT_MANAGER",
      ],
    };
  },
  mounted() {
    if (
      this.getErrors &&
      this.getErrors["critical_error"] &&
      this.getErrors["critical_error"] != "Session Timeout"
    ) {
      this.$store.dispatch("errors/clear");
    } else if (
      this.getErrors &&
      (this.getErrors.email || this.getErrors.password)
    ) {
      this.$store.dispatch("errors/clear");
    }

    this.toggleBodyClass("addClass", "signInPage");
  },
  beforeUnmount() {
    this.toggleBodyClass("removeClass", "signInPage");
  },
  methods: {
    convertToLowerCase(data = "") {
      return data.toLowerCase();
    },
    submitForm(formName) {
      try {
        this.$store.dispatch("session/updateSessionStatus", true);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.signIn();
          } else {
            return false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async signIn() {
      try {
        let params = {
          identifier: this.formData.identifier
            ? this.convertToLowerCase(this.formData.identifier.trim())
            : "",
          password: this.formData.password,
        };
        this.loading = true;
        await this.$store.dispatch("auth/signin", params);
        this.loading = false;
        if (this.getAuthenticationStatus) {
          if (this.$route.query.redirect) {
            this.$router.push({
              name: this.$route.query.redirect,
              params: JSON.parse(this.$route.query.params),
            });
          } else {
            this.goToDashboard();
          }
        } else {
          this.formData.err = this.getGeneralErrorMessage;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    goToDashboard() {
      let query = this.$route.query;

      if (query) {
        let redirect = query.redirect;
        let routerParams = query.params ? JSON.parse(query.params) : {};
        let routerQuery = query.query ? JSON.parse(query.query) : {};
        if (redirect) {
          this.$router.push({
            name: redirect,
            query: routerQuery,
            params: routerParams,
          });
        } else if (
          this.getAuthenticatedUser &&
          this.getAuthenticatedUser.user_type &&
          this.getAuthenticatedUser.user_type === "TOP_DOG"
        ) {
          this.$router.push("/labs");
        } else if (
          this.getAuthenticatedUser &&
          this.getAuthenticatedUser.user_type &&
          this.userTypes.includes(this.getAuthenticatedUser.user_type)
        ) {
          this.$router.push("/all-cases/new-reports");
        } else {
          this.$router.push("/");
        }
      } else {
        this.$router.push("/");
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
};
</script>

<style lang="scss">
#login-page {
  min-height: 100vh;
  background-color: #fff;
  background-image: url(/img/login-background.png);

  .bg-image {
    img {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      object-fit: cover;
      object-position: center;
    }
  }
  .company-logo {
    padding: 0 20px 20px;
    margin-bottom: 40px;
    text-align: center;
    img {
      width: 200px;
    }
  }
  .login-image {
    display: flex;
    align-items: center;
    min-height: 100vh;
  }
  .login-form {
    position: relative;
    .inner-wrap {
      position: relative;
      z-index: 10;
      max-width: 300px;
      padding: 3em 2em 3em;
      margin: 0 auto;
      background: linear-gradient(#ecf2f6, #ecf2f6) padding-box,
        linear-gradient(
            0deg,
            rgba(236, 242, 246, 1),
            rgba(179, 174, 227, 0.4427),
            rgba(230, 227, 255, 1)
          )
          border-box;
      border: 3px solid transparent;
      border-radius: 10%;
      backdrop-filter: blur(18.5px);
      box-shadow: 0px 12px 37px rgba(0, 0, 0, 0.19);

      @media screen and (min-width: 1700px) {
        max-width: 350px;
        padding: 5em 3em;
      }

      .username {
        position: relative;
        margin-bottom: 1.5em;
        .user {
          .el-input__inner {
            height: 40px;
            color: #555073;
            font-family: "Poppins", sans-serif;
            font-weight: 500;
            background: #ffffff;
            padding-left: 50px;
            font-size: 16px;
            border: 1px solid #ffffff;
            border-radius: 10px;
            text-transform: lowercase !important;
            &::placeholder {
              font-weight: 400;
              color: #555073;
              font-size: 16px;
            }
            @media screen and (min-width: 1700px) {
              height: 50px;
            }
          }
        }
      }
      .pswd {
        position: relative;
        .el-input__inner {
          height: 40px;
          color: #555073;
          font-family: "Poppins", sans-serif;
          font-weight: 500;
          padding-left: 50px;
          font-size: 16px;
          background: #ffffff;
          border: 1px solid #ffffff;
          border-radius: 10px;
          @media screen and (min-width: 1700px) {
            height: 50px;
          }
          &::placeholder {
            font-weight: 400;
            color: #555073;
            font-size: 16px;
          }
        }
        .el-input__suffix-inner {
          .el-input__clear {
            right: 40px;
            color: #3084ec;
          }
        }
      }
      .input-icon {
        position: absolute;
        left: 20px;
        top: 10px;
        @media screen and (min-width: 1700px) {
          top: 15px;
        }
        img {
          width: 13px;
          @media screen and (min-width: 1700px) {
            width: 14px;
          }
        }
      }
      .forgot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: -6px 0 14px 0;
        p {
          padding: 0;
          margin-bottom: -2px;
          margin-left: -5px;
          color: #2062ad;
          font-size: 12px;
          font-weight: 400;
        }
      }
      .login-btn {
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        padding: 14px;
        margin-top: 3rem;
        color: white;
        font-size: 16px;
        background-color: rgba(33, 38, 88, 1);

        border: none;
        border-radius: 10px;
      }
    }
  }
  .error {
    color: rgb(177, 29, 29) !important;
    font-size: 13px;
    text-align: left;
    margin-top: 3px;
    .pl-3 {
      padding-left: 3px;
    }
    &.invalid {
      text-align: center;
    }
  }
  .login-image {
    width: 90%;
    margin-left: auto;

    @media screen and (min-width: 1700px) {
      width: 80%;
      margin-left: auto;
    }
    @media (max-width: 991px) {
      display: none;
    }
  }
}
@media screen and (max-width: 375px) {
  .login-form {
    text-align: center;
    .inner-wrap {
      p {
        font-size: 13px !important;
      }
    }
    .forgot {
      display: inline !important;
      .el-checkbox {
        height: 20px;
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .login-form {
    margin: auto 0;
  }
}
</style>
<style lang="scss">
#login-bg {
  .login-page {
    .login-left {
      padding: 4rem 0;
      max-width: 280px;
      .company-logo {
        padding-bottom: 1.5rem;
      }
      .inner-wrap {
        p {
          padding-bottom: 0.7rem;
          color: #233a73;
          font-weight: 400;
          font-size: 14px;
        }
        .el-input {
          .el-input__inner {
            height: 50px;

            border-radius: 10px 10px 0 0;
            .el-input__icon {
              width: 470px;
            }
          }
        }
        .forgot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            margin-left: -4px;
            padding: 0;
            color: #2062ad;
            font-size: 11px;
          }
        }
        .login-btn {
          width: 100%;
          background: linear-gradient(91.35deg, #5277f7 1.15%, #ed4b57 100%);
          color: white;
          font-size: 16px;
          border-radius: 12px;
          padding: 0;
          max-width: 340px;
        }
      }
    }
  }
}
.inner-wrap {
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  .show-icon {
    position: relative;
    .el-button {
      position: absolute;
      right: 10px;
      padding: 0px 11px;
      min-height: 17px;
      border: none;
      background: none;
      top: 35%;
      transition: all 5s ease;

      &:hover {
        background: none;
        border: none;
      }
      &:focus {
        background: none;
        border: none;
      }
    }
    .show-eye-icon {
      img {
        width: 135%;
        height: 135%;
      }
    }
    .hide-eye-icon {
      img {
        width: 135%;
        height: 135%;
      }
    }
  }
}
</style>
